import cn from 'classnames'
import {
  LYSButton,
  LYSSelect,
  LYSSelectOption,
  LYSTypography,
} from '@core/components/Primitives'
import { useTranslation } from '@core/i18n/i18n'
import {
  getPackagingUnitsFromContext,
  useProductContext,
} from '@core/utils/models/product/ProductContext'
import style from './index.module.less'
import { IPackagingUnit } from '@core/api/Products/types'
import { usePageContext } from '@core/utils/pages/PageContext'

const PACKAGE_UNITS_MENU_THRESHOLD = 5

export const packagingUnitButtonTestId = 'packaging-unit-button'

const PackagingUnitSwitch: React.FC = () => {
  const { t } = useTranslation()
  const productContext = useProductContext()
  const {
    props: { isMobile },
  } = usePageContext()
  if (!productContext) {
    return null
  }

  const { packagingUnit, setPackagingUnit, packagingUnits } =
    getPackagingUnitsFromContext(productContext)

  const handleSelectMultiplier = (newPackagingUnit: IPackagingUnit) => {
    if (packagingUnit && setPackagingUnit) setPackagingUnit(newPackagingUnit)
  }

  const handleSelectMultiplierMobile = (e: any) => {
    const newPackagingUnit = packagingUnits.find(
      (units) => units.multiplier === e
    )
    if (newPackagingUnit && setPackagingUnit) setPackagingUnit(newPackagingUnit)
  }

  return packagingUnits && packagingUnits.length > 1 ? (
    <>
      <LYSTypography.Paragraph>
        {t('product.productInformation.packageUnitName')}
      </LYSTypography.Paragraph>
      <div className={style.packagingUnitSwitch}>
        {packagingUnits.length < PACKAGE_UNITS_MENU_THRESHOLD && !isMobile ? ( // if the number of variants is large, we show a dropdown select instead of single buttons
          packagingUnits.map((unit, index) => {
            return (
              <LYSButton
                key={index}
                data-testid={packagingUnitButtonTestId}
                className={
                  unit.multiplier === packagingUnit?.multiplier
                    ? cn(
                        style.packagingUnitSwitchButton,
                        style.packagingUnitSwitchButtonSelected
                      )
                    : style.packagingUnitSwitchButton
                }
                size="small"
                type="primary"
                ghost={true}
                onClick={() => handleSelectMultiplier(unit)}
              >
                {unit.name}
              </LYSButton>
            )
          })
        ) : (
          <LYSSelect
            className={style.packagingUnitSwitchSelect}
            defaultValue={packagingUnits[0].multiplier}
            onSelect={handleSelectMultiplierMobile}
            size={'small'}
          >
            {packagingUnits.map((packagingUnit) => (
              <LYSSelectOption
                key={packagingUnit.name}
                value={packagingUnit.multiplier}
              >
                {packagingUnit.name}
              </LYSSelectOption>
            ))}
          </LYSSelect>
        )}
      </div>
    </>
  ) : null
}

export default PackagingUnitSwitch
